import m from "mithril";

export default {
  view: (vnode) => {
    return (
      <div
        className={`log-book-page-content-inner log-book-page-template mod-01-page`}
      >
        <div className="log-book-text-container mod-01-page">
          <h3 className="log-book-text mod-h3">Introduction</h3>
          <p className="log-book-text">Du skal nu rejse tilbage til 1962 og udforske et af de mest utrolige steder fra Den Kolde Krig: Camp Century. </p>
          <p className="log-book-text">Gå ind i tunnellerne, lyt til de personer, du møder, søg information. Og find til sidst frem til basens tophemmelige formål.</p> 
          <p className="log-book-text">Undervejs skal du forholde dig til en række spørgsmål.</p> 
          <ul>
            <li><p className="log-book-text">Hvorfor blev basen bygget?</p></li>
            <li><p className="log-book-text">Hvad skete der med de Thuleboere, der levede i området?</p></li>
            <li><p className="log-book-text">Kunne truslen fra Sovjet retfærdiggøre, hvad der foregik i Camp Century?</p></li>
          </ul>
          <p className="log-book-text">Til sidst vender du tilbage til nutiden og får mulighed for at stille spørgsmål til en række nulevende personer, der har et helt særligt forhold til basen.</p>
        </div>

        <button
          className="log-book-btn"
          onclick={(e) => {
            e.stopPropagation();
            vnode.attrs.toggleLogBook(null);
          }}
        >
          {vnode.attrs.unredacted ? "Fortsæt" : "Introduktion"}
        </button>
      </div>
    );
  },
};
